import React from 'react';

const ConfiguratorStep = ({ currentStep, steps, onStepClick, configuration }) => {
  // Prüfen ob ein Schritt verfügbar ist
  const isStepAccessible = (stepId) => {
    if (stepId === 0) return true; // Landingpage immer verfügbar
    if (stepId === 1) return true; // Mastauswahl immer verfügbar
    if (stepId === 2) return configuration.poles.length > 0; // Zubehör nur wenn Mast gewählt
    if (stepId === 3) return configuration.poles.length > 0 && Object.keys(configuration.transport_option).length > 0; // Summary nur wenn Mast und Transport gewählt
    return false;
  };

  const handleStepClick = (stepId) => {
    if (isStepAccessible(stepId) && onStepClick) {
      onStepClick(stepId);
    }
  };

  return (
    <div className="bg-white rounded-2xl shadow-lg p-8 mb-8 animate-slideIn">
      <div className="flex items-center justify-between">
        {steps.map((step, index) => (
          <React.Fragment key={step.id}>
            <div className="flex flex-col items-center flex-1">
              <div
                className={`progress-step ${
                  currentStep === step.id 
                    ? 'active' 
                    : currentStep > step.id 
                    ? 'completed' 
                    : 'inactive'
                } ${isStepAccessible(step.id) ? 'cursor-pointer hover:scale-110 transition-transform' : 'cursor-not-allowed opacity-50'}`}
                onClick={() => handleStepClick(step.id)}
                title={isStepAccessible(step.id) ? `Zu "${step.title}" springen` : 'Schritt noch nicht verfügbar'}
              >
                {currentStep > step.id ? (
                  <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                  </svg>
                ) : (
                  step.id
                )}
              </div>
              <div className="mt-4 text-center">
                <div className={`font-semibold text-sm ${currentStep >= step.id ? 'text-slate-900' : 'text-slate-500'} ${isStepAccessible(step.id) ? 'cursor-pointer hover:text-blue-600' : ''}`}
                     onClick={() => handleStepClick(step.id)}>
                  {step.title}
                </div>
                <div className={`text-xs mt-1 ${currentStep >= step.id ? 'text-slate-600' : 'text-slate-400'}`}>
                  {step.description}
                </div>
              </div>
            </div>
            {index < steps.length - 1 && (
              <div 
                className={`progress-line mx-4 ${
                  currentStep > step.id ? 'completed' : ''
                }`}
              />
            )}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

export default ConfiguratorStep;